<template>
	<div class="location-card__main">
		<div class="location-card__main-content">
			<div class="location-card__info">
				<span class="location-card__number">
					({{ location.locationNumber }})
				</span>
				<Ellipsis
					:data="displayLocationName"
					:textToHighlight="search"
					class="location-card__name"
				></Ellipsis>
			</div>
			<Toggle
				v-model="location.activeBetaFeature"
				variant="condensed"
				@change="updateLocation"
			>
				<template slot="true-value">ON</template>
				<template slot="false-value">OFF</template>
			</Toggle>
		</div>
		<Divider
			v-if="!isLastLocation"
			class="location-card__divider"
			:variant="'horizontal-full-width'"
		/>
	</div>
</template>

<script>
import Ellipsis from '@/components/visual/ellipsis';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import Divider from '@/components/shells/divider/divider';

// // utils
import { createTextValueObj } from '@/utils/object';

export default {
	name: 'LocationCard',
	components: {
		Ellipsis,
		Toggle,
		Divider
	},
	props: {
		location: {
			type: Object,
			default: () => {}
		},
		search: {
			type: String,
			default: ''
		},
		isLastLocation: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		displayLocationName() {
			return createTextValueObj(this.location.locationName, this.search);
		}
	},
	methods: {
		updateLocation() {
			this.$emit('location-updated', this.location);
		}
	}
};
</script>

<style lang="scss" scoped>
.location-card {
	width: calc(100% + 36px);

	&__main-content {
		display: grid;
		grid-template-columns: 1fr auto;
		gap: $gutter-md;

		padding-left: $padding-lg;
	}
	&__info {
		display: flex;
		align-items: center;
		gap: $gutter-sm;
		font-size: $heading-font-size-sm;
		min-width: 100%;
	}
	&__divider {
		margin-top: $gutter-lg;
		margin-bottom: $gutter-lg;
	}
	&__name {
		word-break: break-all;
	}
}
</style>
